// extracted by mini-css-extract-plugin
export var fixedHeader = "header-module--fixedHeader--a1936";
export var siteHeader = "header-module--siteHeader--a69d3";
export var siteLogo = "header-module--siteLogo--6cc5c";